// removed by extract-text-webpack-plugin
module.exports = {"container":"style__container___3l78V","title":"style__title___n7Ene","subtitle":"style__subtitle___2-DRg","inputWrapper":"style__inputWrapper___1Ms2N","input":"style__input___3QRhf","inputPassword":"style__inputPassword___2zdQx","inputError":"style__inputError___GWEGg","inputPasswordForgot":"style__inputPasswordForgot___2mwaf","error":"style__error___3DfZG","button":"style__button___20mon","text":"style__text___pra_Z","textBold":"style__textBold___2v7oP"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/booster-login/style.css
// module id = 1150
// module chunks = 0